(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("colord"), require("colord/plugins/a11y"));
	else if(typeof define === 'function' && define.amd)
		define(["colord", "colord/plugins/a11y"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("colord"), require("colord/plugins/a11y")) : factory(root["colord"], root["colord/plugins/a11y"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__235__, __WEBPACK_EXTERNAL_MODULE__366__) {
return 